'use strict';

angular
  .module('ClinicApp')
  .config(function($stateProvider, authorizationProvider) {
    $stateProvider.state('onboard-v2', {
      url: '/onboard-v2/:clinicId/',
      templateUrl: '/views/onboard-v2.html',
      controller: 'OnboardV2Ctrl',
      data: {
        hideNavigation: true,
      },
      resolve: {
        auth: authorizationProvider.requireAuthorizedUser,
        redirect: function($location, CurrentUser, $timeout, $stateParams) {
          return CurrentUser.waitForUserLoad(CurrentUser.isAuthenticated).then(
            function(authenticated) {
              // We are in the middle of a location change, so,
              // our $location.replace() has to run on the next digest.
              function redirectToPath(path) {
                $timeout(function() {
                  $location.path(path).search($stateParams)
                    .replace();
                });
              }

              if (authenticated) {
                return redirectToPath(
                  '/onboard-v2/' + $stateParams.clinicId + '/welcome/',
                );
              }

              return redirectToPath('/login/');
            },
          );
        },
      },
    });

    $stateProvider.state('onboard-step', {
      url: '/onboard-v2/:clinicId/:stepId/',
      templateUrl: '/views/onboard-v2.html',
      controller: 'OnboardV2Ctrl',
      data: {
        hideNavigation: true,
      },
      resolve: {
        auth: authorizationProvider.requireAuthorizedUser,
        pageTitle: function($pageTitle) {
          $pageTitle.set('Onboarding - Opencare');
        },
      },
    });
  });

angular
  .module('ClinicApp')
  .controller(
    'OnboardV2Ctrl',
    function($scope, $window, $stateParams, ClinicConfig, IframeService) {
      IframeService.setupFunctionCallHandler($scope);

      if ($stateParams.stepId) {
        $scope.step = $stateParams.stepId;
      } else {
        $scope.step = 'welcome';
      }

      $scope.getV4Url = function(stepId) {
        return `${ClinicConfig.CLINIC_APP_V4_URL}/#/onboard/${$stateParams.clinicId}/${stepId}`;
      };

      var onboardUrl = $scope.getV4Url($scope.step);
      angular.element('#onboard-funnel-iframe')[0].src = encodeURI(onboardUrl);

      $scope.nextUrl = function(args) {
        window.history.pushState(
          null,
          null,
          '/#/onboard-v2/' + $stateParams.clinicId + '/' + args + '/',
        );
      };

      $scope.redirectToApp = function() {
        $window.location.href = ClinicConfig.CLINIC_APP_URL;
      };
    },
  );
